import { useStore, useStoreMap } from 'effector-react'
import { useMemo, useState } from 'react'
import { driverModel } from '~/entities/Driver'
import { SMS_CODE_LENGTH } from '~/shared/config/constants'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { usePushCode } from '~/shared/lib/push/usePushCode'
import { formatPhoneNumber } from '~/shared/lib/utils'
import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { VerificationFieldElement } from '~/shared/ui/form'
import { RepeatCode } from '~/shared/ui/RepeatCode'
import { Skeleton } from '~/shared/ui/SkeletonList'
import {
  TIMER_REPEAT_RENTAL_CONTRACT_SIGNING,
  TIMER_REPEAT_RENTAL_CONTRACT_SIGNING_TIME,
} from '../constants'

import { Description, Title, Wrapper } from './styled'

type ConfirmDrawerProps = {
  isShow: boolean
  onOk: (code: string) => void
  onCancel: () => void
  onCodeRepeat?: () => void
  isSubmitting: boolean
}

export function ConfirmDrawer({
  isShow,
  onOk,
  onCancel,
  onCodeRepeat,
  isSubmitting,
}: ConfirmDrawerProps) {
  const phone = useStoreMap(driverModel.$driver, (profile) =>
    profile?.getPhone(),
  )
  const driverPending = useStore(driverModel.getDriverFx.pending)

  const [code, setCode] = useState<string>()

  const handleCodeChange = (code: string) => {
    setCode(code)
  }

  const { error } = usePushCode({
    onCode: handleCodeChange,
  })

  const handleOnOk = () => {
    if (error) {
      snackbarEnqueued({ message: error, variant: 'danger' })
      return
    }
    onOk(code as string)
  }

  const phoneExtra = useMemo(
    () =>
      driverPending ? (
        <Skeleton animated $height={27} />
      ) : (
        formatPhoneNumber(phone)
      ),

    [driverPending, phone],
  )

  return (
    <DrawerComponent isShow={isShow} onCancel={onCancel}>
      <Wrapper>
        <Title>Подтверждение по СМС</Title>

        <Description>
          Введите код, который мы отправили на ваш номер <br />
          {phoneExtra}
        </Description>

        <VerificationFieldElement onChange={handleCodeChange} value={code} />
        <br />

        <RepeatCode
          onCodeRepeat={onCodeRepeat}
          time={TIMER_REPEAT_RENTAL_CONTRACT_SIGNING_TIME}
          storageKey={TIMER_REPEAT_RENTAL_CONTRACT_SIGNING}
        />

        <br />

        <Button
          onClick={handleOnOk}
          loading={isSubmitting}
          fullWidth
          variant='limeFlooded'
          size='large'
          disabled={code?.length !== SMS_CODE_LENGTH}
        >
          Подтвердить
        </Button>
      </Wrapper>
    </DrawerComponent>
  )
}
